export const SERVER_500 = "Server Error";
export const CONNECTION_ERROR = "Your internet connect seems poor";


